import {
  addNotification,
  clearNotification as clearNotificationDispatch,
  NotificationState,
  selectNotification,
} from "../Slices/NotificationSlice";
import { useDispatch, useSelector } from "react-redux";

export const useNotification = () => {
  const dispatch = useDispatch();
  const currentNotification = useSelector(selectNotification);

  const displayNotification = (notification: NotificationState) => {
    dispatch(addNotification(notification));
  };

  const displaySuccess = (message: string) => {
    displayNotification({ message, type: "success" });
  };
  const displayWarning = (message: string) => {
    displayNotification({ message, type: "warning" });
  };
  const displayError = (message: string) => {
    displayNotification({ message, type: "error" });
  };
  const displayInfo = (message: string) => {
    displayNotification({ message });
  };

  const clearNotification = () => {
    dispatch(clearNotificationDispatch());
  };

  return {
    currentNotification,
    clearNotification,
    displayNotification,
    displayError,
    displaySuccess,
    displayWarning,
    displayInfo,
  } as const;
};
